module.exports = __webpack_public_path__ + "img/orderbtn.49b115f8.png";